import gql from "graphql-tag";

export default gql`
  mutation ExportFinancialsSheet(
    $format: String
    $vertical: PlatformVertical = STOCKS
    $statementType: FinancialsStatementType
    $tickerSymbol: TickerSymbol!
    $country: SecurityCountry!
    $currency: String = "USD"
    $limit: Int = 3
    $limitCriterion: FinancialsSheetLimitCriterion
    $financialsTemplate: FinancialsTemplateID
    $indicators: [IndicatorID!]
    $indicatorsCriterion: FinancialsSheetIndicatorsCriterion
    $filterByReportDateAfter: Date
    $filterByReportDateBefore: Date
    $filterByInterim: String
    $filterByCountryCode: String
    $indicatorDataSource: IndicatorDataSource
    $indicatorsPlacement: IndicatorsTablePlacement = END
  ) {
    exportFinancialsSheet(
      format: $format
      vertical: $vertical
      statementType: $statementType
      tickerSymbol: $tickerSymbol
      country: $country
      currency: $currency
      limit: $limit
      limitCriterion: $limitCriterion
      indicators: $indicators
      indicatorsCriterion: $indicatorsCriterion
      financialsTemplate: $financialsTemplate
      filterByReportDateAfter: $filterByReportDateAfter
      filterByReportDateBefore: $filterByReportDateBefore
      filterByInterim: $filterByInterim
      filterByCountryCode: $filterByCountryCode
      indicatorDataSource: $indicatorDataSource
      indicatorsPlacement: $indicatorsPlacement
    )
  }
`;
